import { Directive, ElementRef } from '@angular/core';
declare var $: any;
@Directive({
  selector: '[appDgBs4Tooltip]'
})
export class DgBs4TooltipDirective {

  constructor(private el: ElementRef) {
    console.log("i m in");
    $(el.nativeElement).tooltip();
   } 

}
